import { Component, OnInit, SimpleChanges, OnChanges, Input, ViewChild } from '@angular/core';
import { OrderService } from 'src/app/_services/dispo/order.service';
import { CustomerBranchService } from 'src/app/_services/dispo/customer-branch.service';
import { AbstractControl, FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TeamBaseService } from 'src/app/_services/dispo/team-base';
import { CustomerService } from 'src/app/_services/cinema/customer.service';
import { prepareEventListenerParameters } from '@angular/compiler/src/render3/view/template';
import { PerfectScrollbarComponent,PerfectScrollbarConfig, PerfectScrollbarConfigInterface, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-team-location',
  templateUrl: './team-location.component.html',
  styleUrls: ['./team-location.component.css']
})
export class TeamLocationComponent implements OnInit {
  content: any;
  orderData: any;
  teamForm: any;
  orderTypeList: any;
  customerBranchList: any;
  orderList: any;
  customerList: any;
  isNew: Boolean = false;
  addNew: Boolean = false;
  customer_id: any;
  submitted = false;
  teamBaseData: any;
  teamLocations: any;
  teamLocationsAry: any;
  loading: any;
  public configPS: PerfectScrollbarConfigInterface = { wheelPropagation: true }; @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent; directiveRef?: PerfectScrollbarDirective;

  constructor(
    private orderService: OrderService,
    private customerBranchService: CustomerBranchService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private teamBaseService: TeamBaseService,
    private customerService: CustomerService
  ) { }

  ngOnInit(): void {
     //get current movie data
     this.loading = true;
     this.teamBaseService.getCurrentObject().subscribe( data => {
        this.teamBaseData = data.teamBase;
        this.teamLocationsAry = data.teamBase.team_locations;
        this.fetchCustomer();
        this.loading = false;
      },
      err => { this.content = JSON.parse(err.error).message;}
    );
  }

  fetchCustomer() {
    this.customerService.getAll().subscribe( data => {
      this.customerList = data;
      this.teamLocations = this.teamBaseData.team_locations || [];
      this.customerList.forEach(cat => {
        cat.customer_branch.forEach(branch => {
          branch.selected = this.teamLocationsAry.includes(branch.id);
        });
      });
    },
    err => { this.content = JSON.parse(err.error).message;}
  );
  }

  countSelectedBranches(branchItems) {
    return branchItems.filter(branch => branch.selected).length;
  }

  updateTeamLocations(branch: { selected: boolean; id: number }): void {
    console.log('change TeamLocation');
    if (!branch || typeof branch.selected !== 'boolean' || typeof branch.id !== 'number') {
      console.error('Invalid skill object provided');
      return;
    }
  
    if (branch.selected) {
      if (!this.teamLocations.includes(branch.id)) {
        this.teamLocations.push(branch.id);
      }
    } else {
      this.teamLocations = this.teamLocations.filter(id => id !== branch.id);
    }
   
  }

  store() {
    
    this.teamBaseService.storeTeamLocations(this.teamBaseData.id, this.teamLocations).subscribe(
      data => {
        this.orderData = data;
        this.toastr.success('Klassifikation gespeichert', 'Daten gepeichert!');
      },
      err => {
        this.toastr.warning(err.error.message, 'Ein Fehler ist aufgetreten');
      }
  )};



}
